import React from 'react';
import PropTypes from 'prop-types';
import { prettyNumber, metersToMiles } from '../../../../../lib/utils';
import DataPoint from '../DataPoint';

export default function LineStats(props) {
  const line = props.feature;

  const hasGeometry = () => {
    return line && line.geometry && line.geometry.coordinates;
  };

  const getDistance = () => {
    if (
      hasGeometry() &&
      line.properties != null &&
      line.properties.distance != null &&
      line.properties.distance !== 0
    ) {
      return prettyNumber(metersToMiles(line.properties.distance), 2);
    }
    return '--';
  };

  return (
    <>
      <DataPoint title='Distance'>
        { getDistance() + ' miles'}
      </DataPoint>
    </>
  );
}

LineStats.propTypes = {
  feature: PropTypes.object,
};
